<template>
	<layout-admin-auto-loading class="admin-subscription-list" :loader="getSubscriptions" :loading="loading" :finished="finished" :error="error">
		<div slot="breadcrumbs"><admin-breadcrumbs :breadcrumbs="breadcrumbs"/></div>
		<div slot="header" class="slot">
			<h1>{{ title }}</h1>
		</div>
		<div slot="body">
			<admin-data-table :finished="finished" :table_columns="table_columns" :table_rows="table_rows"/>
		</div>
	</layout-admin-auto-loading>
</template>

<script>
import LayoutAdminAutoLoading from '../LayoutAdminAutoLoading'
import AdminBreadcrumbs from '../AdminBreadcrumbs'
import AdminDataTable from '../AdminDataTable'
export default {
	components: {
		LayoutAdminAutoLoading,
		AdminBreadcrumbs,
		AdminDataTable
	},
	data () {
		return {
			title: 'Subscription List',
			loading: false,
			error: null,
			data: [],
			finished: false,
			limit: 20,
			table_columns: [
				{
					label: 'UID',
					field: 'user_uid',
				},
				{
					label: 'Name',
					field: 'user_fullname'
				},
				{
					label: 'Subscriptions',
					field: 'subscriptions'
				},
				{
					label: 'Active',
					field: 'subscriptions_active'
				},
				{
					label: 'Waiting first payment',
					field: 'subscriptions_waiting_first_payment'
				},
				{
					label: 'Waiting payment',
					field: 'subscriptions_waiting_payment'
				},
				{
					label: 'Total',
					field: 'subscriptions_total'
				},
				{
					label: '',
					width: '50px'
				}
			]
		}
	},
	computed: {
		breadcrumbs () {
			return [
				{
					title: this.title
				}
			]
		},
		offset () {
			return this.data.length
		},
		table_rows () {
			return this.data.map(row => {
				return {
					columns: [
						{
							field: 'user_uid',
							type: 'link',
							value: { title: row.user_uid, to: { name: 'WatchList', params: { user_uid: row.user_uid } } }
						},
						{ field: 'user_fullname', value: row.user_fullname },
						{ field: 'subscriptions', value: row.subscriptions },
						{ field: 'subscriptions_active', value: row.subscriptions_active },
						{ field: 'subscriptions_waiting_first_payment', value: row.subscriptions_waiting_first_payment },
						{ field: 'subscriptions_waiting_payment', value: row.subscriptions_waiting_payment },
						{ field: 'subscriptions_total', value: `${row.subscriptions_total}€` },
						{
							field: 'operations',
							type: 'operations',
							value: [
								{ title: 'Profile', to: { name: 'UserProfileAccount', params: { user_uid: row.user_uid } } },
								{ title: 'Pacients', to: { name: 'UserWatchesPatients', params: { user_uid: row.user_uid } } },
								{ title: 'Devices', to: { name: 'UserWatchesDevices', params: { user_uid: row.user_uid } } },
							]
						}
					]
				}
			})
		}
	},
	methods: {
		getSubscriptions () {
			this.loading = true
			this.$api.subscriptions.admin.getAll(this, this.offset, this.limit)
				.then(response => {
					this.$log.info('admin', 'subscriptions.admin.getAll OK', response)()
					if (response.body.length) {
						this.data = this.data.concat(response.body)
					}
					if (!response.body.length || response.body.length < this.limit) {
						this.finished = true
					}
				})
				.catch(error => {
					this.$log.error('admin', 'subscriptions.admin.getAll ERROR', error)()
					this.error = error
				})
				.finally(() => {
					this.loading = false
				})
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/admin/subscriptions/SubscriptionList.vue